import { jsx as o, jsxs as r } from "react/jsx-runtime";
import { MainSearchBar as e, SearchBar as u } from "@intergamma/search-bar";
import { S as s } from "./LoadingSearch-CoWrQPFm.js";
import { cn as n } from "@intergamma/common/cn";
import { useRef as p } from "react";
import { focusOutline as l } from "@intergamma/ui/helpers/focusOutline";
function S() {
  return /* @__PURE__ */ o(s, { children: /* @__PURE__ */ o(e, {}) });
}
function v(t) {
  return /* @__PURE__ */ o(s, { children: /* @__PURE__ */ o(u, { ...t }) });
}
const c = () => /* @__PURE__ */ o(
  "div",
  {
    className: n(
      "fixed inset-0 -z-30 transform-gpu bg-transparent group-focus-within:backdrop-blur-sm pointer-events-none",
      "group-focus-within:z-[9950] group-focus-within:block group-focus-within:bg-black/50",
      "transition-all duration-300 ease-in-out"
    )
  }
), h = () => /* @__PURE__ */ o(
  "div",
  {
    onMouseDown: (t) => t.preventDefault(),
    className: n(
      "fixed top-0 inset-x-0 z-[-100] w-full h-[150dvh] touch-manipulation bg-white/0 transition duration-300 pointer-events-none",
      "group-focus-within:z-[9950] group-focus-within:bg-white",
      "transition-colors duration-[600ms] ease-in-out",
      "overscroll-y-contain [scrollbar-width:none] group-focus-within:overflow-y-auto [&::-webkit-scrollbar]:hidden"
    )
  }
), f = ({
  children: t,
  variant: i = "old"
}) => /* @__PURE__ */ o(
  "div",
  {
    className: n(
      "absolute flex ease-in-out motion-safe:transition-all motion-safe:duration-[400ms]",
      i === "old" ? n(
        "left-[-10px] w-[calc(100%+20px)] pb-[12px] pl-[110px] pr-[10px]",
        "group-focus-within:top-[10px] group-focus-within:z-[9951] group-focus-within:pl-[10px] group-focus-within:pt-[10px]",
        "top-[59px] karwei:top-[65px]",
        "lg:bottom-[-12px] lg:top-auto"
      ) : "inset-0 items-center group-focus-within:left-[-42px] group-focus-within:right-[54px] group-focus-within:top-[-38px] group-focus-within:z-[9951]"
    ),
    "data-variant": i,
    children: t
  }
);
function k() {
  return /* @__PURE__ */ r("div", { className: "group contents", children: [
    /* @__PURE__ */ o(
      "div",
      {
        className: n(
          "w-full",
          "md:ease md:absolute md:inset-x-auto md:top-[57px] md:z-[11] md:w-[200px] md:transition-[right] md:duration-100",
          "group-focus-within:md:z-[9951] lg:w-56",
          "lg:relative lg:right-auto lg:top-0 xl:ml-8",
          "xl:w-[376px]"
        ),
        children: /* @__PURE__ */ o(e, {})
      }
    ),
    /* @__PURE__ */ o(c, {})
  ] });
}
function z({
  variant: t
}) {
  const i = p(null);
  return /* @__PURE__ */ r("div", { className: "group contents", ref: i, children: [
    /* @__PURE__ */ r(f, { variant: t, children: [
      /* @__PURE__ */ o(e, {}),
      /* @__PURE__ */ o(
        "button",
        {
          onClick: (a) => {
            a.currentTarget.blur();
          },
          className: n(
            "hidden group-focus-within:flex",
            "ml-2.5 size-[46px] flex-[0_0_46px] flex-col items-center pt-[11px] karwei:pt-[9px]",
            l,
            "gamma:rounded",
            t === "new" && "absolute left-full !p-0 justify-center"
          ),
          children: /* @__PURE__ */ r(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [
                /* @__PURE__ */ o("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
                /* @__PURE__ */ o("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
              ]
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ o(h, {})
  ] });
}
export {
  S as M,
  v as S,
  c as a,
  h as b,
  f as c,
  k as d,
  z as e
};
